// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"3415":"c36f3faa","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"1251":"f36429bdf2937d1c","3415":"73c83a15e3b65eca","3969":"bce16c43dcce319c","4495":"ea260c6f243d4a58","8445":"506568f878839125"}[chunkId] + ".js";
};